import Breadcrumb from '../../components/Breadcrumb'

import img1 from '../../img/icons/rules/days.webp'
import img2 from '../../img/icons/rules/hedging.webp'
import img3 from '../../img/icons/rules/limit.webp'
import img4 from '../../img/icons/rules/profitbag.webp'
import img5 from '../../img/icons/rules/spilit.webp'
import img6 from '../../img/icons/rules/sustainable.webp'
import img7 from '../../img/icons/rules/target.webp'

export default function PageRules() {

    return (
        <>
            <Breadcrumb className="" breadcrumbIcon="UserCircleSvg" breadcrumbHeading="Rules" />
            <div className="container-lg cl-custome3">
                <div className="common-box account-list-box">

                    <div className="alb-data">
                        <div className={`row row-gap-1 px-2`}>

                            <div className="legal-content lc-wimg">
                                <img src={img7} alt="" />
                                <div className="">
                                    <div className="legal-heading">Profit Target</div>
                                    <p>Profit Target Percentage Will Based on account Type.</p>
                                    <p>i.e,</p>
                                    <p className="mt-1"><strong>Step 1 Accounts:</strong></p>
                                    <p>10% of Acc size</p>
                                    <p className="mt-2"><strong>Step 2 accounts:</strong></p>
                                    <p>Phase 1 - 8% of Acc size</p>
                                    <p>Phase 2- 5% of Acc Size</p>
                                </div>
                            </div>

                            <div className='common-section-separator lc-css'></div>

                            <div className="legal-content lc-wimg">
                                <img src={img1} alt="" />
                                <div className="">
                                    <div className="legal-heading">Trading Days</div>
                                    <p>You should trade for a minimum of 7 days on each challenge phase as well as the real account.</p>
                                </div>
                            </div>

                            <div className='common-section-separator lc-css'></div>

                            <div className="legal-content lc-wimg">
                                <img src={img4} alt="" />
                                <div className="">
                                    <div className="legal-heading">Daily Profit Cap – 3%</div>
                                    <p>Traders can earn a maximum of 3% of their account size per calendar day in profit. This prevents overleveraging and emotional trading while encouraging consistent gains.</p>
                                    <p className="mt-2"><strong>Profit Lock Option (Default):</strong> </p>
                                    <p>After reaching 3%, trading profits will not be considered for the day.</p>
                                    <p className="mt-2"><strong>Add-On (For Elite Traders):</strong></p>
                                    <p>Consistent traders may unlock 4–5% daily caps after 2+ months of rule-compliant performance.</p>
                                </div>
                            </div>

                            <div className='common-section-separator lc-css'></div>

                            <div className="legal-content lc-wimg">
                                <img src={img2} alt="" />
                                <div className="">
                                    <div className="legal-heading">No Hedging</div>
                                    <p>Hedging Between Two Accounts or You cannot have both a buy position and a sell position open at the same time.</p>
                                </div>
                            </div>

                            <div className='common-section-separator lc-css'></div>

                            <div className="legal-content lc-wimg">
                                <img src={img5} alt="" />
                                <div className="">
                                    <div className="legal-heading">Profit Split</div>
                                    <p>1st Month - 90%</p>
                                    <p>2nd Month - 95%</p>
                                    <p>3rd Month - 100%</p>
                                </div>
                            </div>

                            <div className='common-section-separator lc-css'></div>

                            <div className="legal-content lc-wimg">
                                <img src={img3} alt="" />
                                <div className="">
                                    <div className="legal-heading">Exceed Limit</div>
                                    <p>Hitting either the daily loss limit or the maximum loss limit will result in a permanent account breach.</p>
                                </div>
                            </div>

                            <div className='common-section-separator lc-css'></div>

                            <div className="legal-content lc-wimg">
                                <img src={img6} alt="" />
                                <div className="">
                                    <div className="legal-heading">Sustainable Growth Cap (SGC)</div>
                                    <p>Monthly 10% Profit Cap (relative to account size) that can be increased through consistent trading.</p>
                                    <p className="mt-2"><strong>Scaling Milestones:</strong></p>
                                    <p>Month 1: 10% | After 2 Months: 12.5% After 3 Months: 15% | After 4+ Months: 20%</p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}
